import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { deactivateColumns } from "../../../../constants/lineListColumns";
import { __getDeactivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const ClientDeactivateBatch = () => (
  <BatchDetail
    title="Deactivate"
    apiGet={__getDeactivate}
    columnsFactory={(ctx) => deactivateColumns({ ...ctx, iccidHeaderName: "ICCID" })}
    copyKeys={COPY_KEYS}
    exportAction="deactivate"
    retryOperation="deactivate"
    showCheckStatus
    checkStatusOperation="deactivate"
    showTerminate
    terminateOperation="deactivate"
  />
);

export default ClientDeactivateBatch;
